import React, { useState } from 'react';
import { Apify } from '../Apify';
import Butt from './Butt';
import API from '../API';
import { T } from '../traks';

export default Apify("/a/is_following")
	.with_query_from_props((props) => ({user_id: props.user_id || 0}))
	.with_response_prop("is_following")
	.wrap((props) => {
		const [is_following, set_is_following] = useState(props.is_following.IsFollowing);

		const unfollow = () => {
			API.post("/a/unfollow", {user_id: props.user_id}, (response) => {
				set_is_following(false);
			});
		};

		const follow = () => {
			API.post("/a/follow", {user_id: props.user_id}, (response)  => {
				set_is_following(true);
			});
		};

		const name = props.is_following.Name;

		return null;
	});



// WEBPACK FOOTER //
// ./src/c/Follow.js